package org.multiplatform.kotfolio.pages.coroutines

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul

@Page("/coroutines/flow_on")
@Composable
fun FlowOnPage() {
    BlogLayout(
        PageProperties(
            "flowOn() Operator",
            ""
        ),
        BlogProperties("Coroutines", "flowOn() Operator")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "flowOn() Operator",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The flowOn operator is used to change the coroutine context of the upstream operations in a flow. This is particularly useful when you need to specify a different thread or dispatcher for specific parts of a flow pipeline, without affecting the downstream operations (like collection).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The same effect appears if the context of the emission and use parts is different.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Scope: Permanent switch of context for the part of the flow upstream of the flowOn. It's like assigning a chef to a station for a particular type of task…",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "flowOn operator is used to change the context (dispatcher) of a flow. It's particularly useful when you want to specify on which dispatcher the upstream operations of a flow should run. Of all the operators, only one onStart and two flowOn were executed.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Is very handy when it comes to controlling the thread on which the task will be done. flowOn exception refers to a function used to change the context of the flow emission.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Usually, in Android, we do a task on a background thread and show the result on the UI thread.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "flowOn method is used to switch the upstream flow to the scheduler of the specified coroutine context for execution, and will not expose the coroutine context to the downstream flow, that is, the scheduler of the coroutine context in the flowOn method will not take effect on the downstream flow.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "suspending functions in Kotlin can only return a single value; Flow can return multiple values.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flow sequence is a cold stream as well flow Code inside the builder won’t run until it’s collected.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "You can think of Flow as a stream. Values flow downstream like water in a river. Values can be created from asynchronous actions such as network requests or database calls. If you are familiar with RxJava — Flow behaves similarly to Observable and Flowable. Flow is built on top of coroutines. We love coroutines because they bring structured concurrency to Kotlin.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This allows you to perform operations like network requests or database queries on a background thread, while keeping the downstream operations on the main thread if necessary.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It’s referred to as “cold”, because the flow (or stream if you like) doesn’t exist before collect is called and is created again every time collect is called. If the flow was there anyway and we just listened to it, then it would be “hot”.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "flowOn() is like subscribeOn() in RxJava",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "Use: Use when you want to change the context for the entire upstream operations in a flow, ensuring that all emissions and intermediate steps happen on a specific dispatcher…",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            //All children are cancelled (unless using SupervisorJob/supervisorScope semantics)
            //Inner flows run concurrently; emissions interleave based on completion timing

            SpanText(
                text = "flowOn() Work",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "flowOn changes the context of the flow it is applied to, but only for the operations above it (upstream operations). The downstream operations will continue in the original context.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This is particularly useful to offload heavy operations to a background thread while keeping the flow consumption on the main thread.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "flowOn{} is like permanently assigning a new chef to a different station for a specific task. Imagine you have a chef dedicated to prepping vegetables. You decide that for all vegetable prep tasks, this chef will always work at the prep station, regardless of where the other tasks in the workflow are happening. This allows you to define the context for a particular part of the workflow, and it stays consistent for that part…",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    flow {
                        // Emit some values
                    }
                    .flowOn(Dispatchers.IO)
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    val flow = flow {
                        // Run on Background Thread (Dispatchers.Default)
                        (0..10).forEach {
                        // emit items with 500 milliseconds delay
                        delay(500)
                        emit(it)
                    }
                }
                .flowOn(Dispatchers.Default)
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    interface PostApi {
                        @GET("posts")
                        suspend fun getPost(): List<Post>
                    }
                    
                    interface Repository {
                        suspend fun getPost(): Flow<List<Post>>
                    }
                    
                    class RepositoryImpl @Inject constructor(
                        private val api: PostApi
                    ): Repository {

                        override suspend fun getPost(): Flow<List<Post>> = flow {
                            emit(api.getPost())
                        }.flowOn(Dispatchers.IO)
                    }
                    
                    /*
                        //flowOn error handle
                        override fun getWeather(query: String?) = flow<WeatherResult<WeatherModel>> {
                            emit(WeatherResult.Success(dataSource.getWeatherInfo().toDomain()))
                        }.catch {
                            emit(WeatherResult.Error(it))
                        }.flowOn(ioDispatcher)
                    */
                    
                    @HiltViewModel
                    class PostViewModel @Inject constructor(
                        private val repository: Repository,
                    ) : ViewModel() {
                        
                        fun getRequest(){
                            viewModelScope.launch {
                                repository.getPost().onStart {
                                  
                                }.catch {
                                   
                                }.collect {
                                    
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "flowOn() Error Handling",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    @Entity(tableName = "notes")
                    data class Note(
                        @PrimaryKey(autoGenerate = true)
                        @ColumnInfo("note_id") val note_id:Int?,
                        @ColumnInfo("note_title") val note_title:String,
                        @ColumnInfo("note_detail") val note_detail:String,
                        @ColumnInfo("note_date") val note_date:String,
                        @ColumnInfo("priority") val priority: Priority? = Priority.LOW
                    )
                    
                    enum class Priority {
                        HIGH,
                        MEDIUM,
                        LOW
                    }
                    
                    sealed class Resource<T>(val data: T? = null, val msg: String? = null) {
                        class Success<T>(data: T?) : Resource<T>(data = data)
                        class Error<T>(msg: String) : Resource<T>(msg = msg)
                        class Loading<T> : Resource<T>()
                    }
                    
                    @Dao
                    interface NotesDao {
                        @Query("SELECT*FROM notes")
                        suspend fun allNotes():List<NoteDto>
                    }
                    
                    fun NoteDto.toDomainNote() : Note{
                        return Note(
                            note_id, note_title, note_detail, note_date,priority
                        )
                    }
                    
                    interface NoteInterface {
                        fun allNotes(): Flow<Resource<List<Note>>>
                    }
                    
                    class RepositoryImpl @Inject constructor(
                        private val notesDao: NotesDao
                    )  : NoteInterface {
                        override fun allNotes(): Flow<Resource<List<Note>>> = flow {
                            emit(Resource.Loading())

                            val result = notesDao.allNotes().map {
                                it.toDomainNote()
                            }
                            emit(Resource.Success(result))
                        }.flowOn(Dispatchers.IO)
                            .catch {
                                emit(Resource.Error(it.message.toString()))
                            }
                    }
                    
                    class GetAllNotesUseCase @Inject constructor(
                        private val noteInterface: NoteInterface
                    ) {
                        operator fun invoke() = noteInterface.allNotes()
                    }
                    
                    @HiltViewModel
                    class MainPageViewModel @Inject constructor(
                        private val getAllNotesUseCase: GetAllNotesUseCase,
                        private val deleteNoteUseCase: DeleteNoteUseCase,
                        private val searchUseCase: SearchUseCase
                    ) : ViewModel() {
                        
                        private val _noteListState = MutableStateFlow(NoteListState())
                        val noteListState : StateFlow<NoteListState> get() = _noteListState

                        private fun getAllNotes(){
                            getAllNotesUseCase().onEach { result->
                                when(result){
                                    is Resource.Error -> {
                                        _noteListState.value = NoteListState().copy(
                                            errorMsg = result.msg
                                        )
                                    }
                                    is Resource.Loading -> {
                                        _noteListState.value = NoteListState().copy(
                                            isLoading = true
                                        )
                                    }
                                    is Resource.Success -> {
                                        _noteListState.value = NoteListState().copy(
                                            notes = result.data
                                        )
                                    }
                                }
                            }.launchIn(viewModelScope)
                        }
                    }
                    
                    data class NoteListState(
                        val notes: List<Note>? = emptyList(),
                        val errorMsg: String ?= "",
                        val isLoading : Boolean = false
                    )
                    
                    data class NoteState(
                        val note: Note? = null,
                        val errorMsg: String ?= "",
                        val isLoading : Boolean = false
                    )
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Module
                    @InstallIn(SingletonComponent::class)
                    object AppModule {
                        @Provides
                        @Singleton
                        fun provideRmDatabase(@ApplicationContext context: Context): RmDatabase {
                            return Room.databaseBuilder(
                                context,
                                RmDatabase::class.java,
                                "Note"
                            ).build()
                        }

                        @Provides
                        @Singleton
                        fun provideNotesDao(rmDatabase: RmDatabase): NotesDao {
                            return rmDatabase.notesDao()
                        }

                        @Provides
                        @Singleton
                        fun providesNInterface(notesDao: NotesDao): NoteInterface {
                            return RepositoryImpl(notesDao)
                        }
                    }
                    """.trimIndent()
            )
        }
    }
}